import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section id="top" className="relative bg-[#fbf7ee]">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14 pt-10 md:pt-16 lg:pt-24 pb-20 lg:pb-28 text-center">
        <h1
          className="font-display text-[#1e2952] text-[46px] sm:text-[60px] md:text-[72px] lg:text-[84px] leading-[1.02] tracking-tight animate-rise"
          style={{ fontWeight: 500 }}
        >
          Forming Souls.
          <br />
          Cultivating Wisdom.
        </h1>

        <div className="mt-10 flex items-center justify-center gap-4 animate-rise delay-1">
          <span className="block h-px w-40 bg-[#c9a961]"></span>
          <span className="text-[#c9a961] text-lg">†</span>
          <span className="block h-px w-40 bg-[#c9a961]"></span>
        </div>

        <p className="font-serif-body mt-10 text-[#3a466e] text-[18px] md:text-[20px] leading-[1.7] max-w-[720px] mx-auto animate-rise delay-2">
          Angel of Peace Academy is an independent K–8 school committed to
          providing a thorough education in the Classical Liberal Arts in
          harmony with the fullness of the Catholic faith.
        </p>

        <p className="font-serif-body mt-6 text-[#3a466e] text-[18px] md:text-[20px] leading-[1.7] max-w-[720px] mx-auto animate-rise delay-2">
          Students are formed through rich Humanities, rigorous academics, prayer, Holy Mass, and a vibrant, faithful school community.
        </p>

        <p className="font-serif-body mt-6 text-[#3a466e] text-[18px] md:text-[20px] leading-[1.7] max-w-[720px] mx-auto animate-rise delay-2">
          Our weekly model combines three days of core academic instruction with two dedicated days for faith formation, fine arts, physical education, and electives. Together, these five days offer a complete school experience while allowing enrollment flexibility that best suits the needs of individual families.
        </p>

        <p className="font-serif-body mt-6 text-[#3a466e] text-[18px] md:text-[20px] leading-[1.7] max-w-[720px] mx-auto animate-rise delay-2">
          The Academy operates with complete fidelity to the Catholic Church but is not officially associated with the Diocese of Dallas or any individual parish.
        </p>

        <div className="mt-12 flex items-center justify-center animate-rise delay-3">
          <Link
            to="/school-format"
            className="btn-navy font-sans-nav text-[12px] tracking-[0.24em] uppercase px-10 py-4 text-center leading-[1.5]"
          >
            Learn About Our<br />School Format
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
